import { useMemo, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_USER_INFO } from 'redux/constant/user'
import { selectInviteCode, selectUserInfo } from 'redux/selector/user'
import { report } from 'hooks/useAnalytics'

import { useAlert, positions } from 'react-alert'
import { fetchFindPreviousAccount } from 'api'

import HeaderBox from 'component/PageModalHeaderBox'

import useOpenModal from './hooks/useOpenModal'

import { Content, Item, ArrowRight } from './Styled'

import md5 from 'md5'
import { HeaderWrap, PageScrollWrap, PageWrapperNonScroll } from 'commonStyledComponents'
import IDCardScanner from './component/IDCardScanner'
import { useNavigateTo } from 'hooks/useNavigateTo'
import { useAppNavigate } from 'app-layered-layout/useAppNavigate'
import useDevButtonClick from 'hooks/useDevButtonClick'

export const checkDebugSecret = (str: string) => {
  return md5('SSSSEEECCCRRREEETTT' + (str ?? '')) === '725ea846597e362511f6bae1d8d068db'
}

export default function SystemConfig() {
  const dispatch = useDispatch()
  const { openIDCard } = useOpenModal()
  const navigate = useAppNavigate()
  const { navigateToDebugPage } = useNavigateTo()
  const [scannerShowing, setScannerShowing] = useState<boolean>()
  const userInfo = useSelector(selectUserInfo)
  const inviteCode = useSelector(selectInviteCode)
  const shortId = userInfo?.show_id ?? inviteCode ?? 'unknown'

  const handleFindPreviousAccount = useCallback(() => {
    setScannerShowing(true)
  }, [])

  const alert = useAlert()

  const onScan = (decodedText: string) => {
    // success, use decodedText
    console.log(decodedText)
    fetchFindPreviousAccount({ code: decodedText })
      .then(() => {
        // 重新使用deviceId獲取用戶資料
        setScannerShowing(false)
        alert.info('欢迎回来', {
          position: positions.MIDDLE,
          offset: '300px',
          timeout: 1500,
        })
        dispatch({ type: FETCH_USER_INFO })
        setTimeout(() => {
          navigate('/', { replace: true, dropStack: true })
        }, 1500)
      })
      .catch((e: any) => {
        console.log(e)
        if (e.message) {
          alert.info('无法找回会员ID，' + e.message, {
            position: positions.MIDDLE,
            offset: '300px',
            timeout: 1500,
          })
        } else {
          alert.info('无法找回会员ID，请联系客服' + e.message, {
            position: positions.MIDDLE,
            offset: '300px',
            timeout: 1500,
          })
        }
        // openHintModal({
        //   children: FindAccountFailed,
        //   props: {},
        // });
      })
  }
  const onScanError = () => {
    // openHintModal({
    //   children: FindAccountFailed,
    //   props: {},
    // });

    alert.info('辨识失败，这似乎不是正确的身份卡', {
      position: positions.MIDDLE,
      offset: '300px',
      timeout: 1500,
    })
  }

  const items = useMemo(
    () => [
      {
        label: '帐号凭证',
        callback: openIDCard,
        testId: 'settings_account_credential_item',

      },
      {
        label: '找回帐号',
        callback: handleFindPreviousAccount,
      },
    ],
    [handleFindPreviousAccount, openIDCard]
  )

  function onClickVersion() {
    // Matomo 埋點：Debug Mode 相關事件
    // 觸發密碼彈窗
    report({ category: 'debug_mode', action: 'password_popup', name: shortId })
    const input = prompt()
    if (input && checkDebugSecret(input)) {
      navigateToDebugPage({
        secret: input,
      })
    }
  }
  const { handleButtonClick, handleButtonDown, handleButtonUp } = useDevButtonClick(onClickVersion)

  return (
    <PageWrapperNonScroll>
      <HeaderWrap>
        <HeaderBox
          headerTitle={'设置页面'}
          onClose={({ close }) => {
            close()
          }}
        />
      </HeaderWrap>
      <PageScrollWrap noPadding>
        <Content>
          {items?.map((item, i) => {
            return (
              <Item
                key={i}
                onClick={item.callback}
                {...('testId' in item && item.testId
                  ? { 'data-testid': item.testId, 'aria-label': item.testId }
                  : {})}
              >
                {item.label}
                <ArrowRight />
              </Item>
            )
          })}

          {process.env.REACT_APP_FAST_DEBUG_TOOL === 'true' ? (
            <Item onClick={onClickVersion}>
              当前版本号码
              <div>{process.env.REACT_APP_VERSION}</div>
            </Item>
          ) : (
            <Item
              onClick={handleButtonClick}
              onPointerDown={handleButtonDown}
              onPointerUp={handleButtonUp}
              onContextMenu={(e) => e.preventDefault()}
            >
              当前版本号码
              <div>{process.env.REACT_APP_VERSION}</div>
            </Item>
          )}

          {scannerShowing && (
            <IDCardScanner
              qrCodeSuccessCallback={onScan}
              qrCodeErrorCallback={onScanError}
              onClose={() => setScannerShowing(false)}
            />
          )}
        </Content>
      </PageScrollWrap>
    </PageWrapperNonScroll>
  )
}
